<template>
  <form @submit.prevent="handleSubmit" class="search-form">
    <div class="auto-complete-input">
      <input
        type="text"
        v-model="searchQuery"
        @input="handleInput"
        @focus="showSuggestions = true"
        @blur="handleBlur"
        :placeholder="label"
        class="input-field"
      />
    </div>
    <button type="submit" :disabled="isSubmitting" class="submit-button">{{ submitText }}</button>
  </form>
</template>

<script>


export default {
  props: {
    isSubmitting: Boolean,
    label: {
      type: String,
      default: '输入概念、价升量缩等，多个条件用分号隔开，如"价升量缩;概念:科技;市值:300亿以下'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputId: {
      type: String,
      default: 'stock-code'
    },
    submitText: {
      type: String,
      default: '问财'
    }
  },
  data() {
    return {
      searchQuery: '',
      suggestions: [],
      showSuggestions: false,
      timeout: null
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', this.searchQuery);
    }
  }
};
</script>

<style scoped>
@import '../assets/css/WcSearchForm.css';
</style>